export default "__VITE_ASSET__37a15c9f__"